import styles from './CarrelloFooterTitleRow.module.scss';
import { useGetLabelsByKeys } from 'hooks/useLingUI';
import { useMemo } from 'react';

export type CarrelloFooterTitleRowProps = {
  tipoCarrello: TipoCarrello;
  numItem: number;
  hasOnlyHorizontalPadding?: boolean;
};

/* eslint-disable no-unused-vars */
export enum TipoCarrello {
  Multipla = 'multipla',
  Sistema = 'sistema',
}
/* eslint-enable no-unused-vars */

export const CarrelloFooterTitleRow = ({
  tipoCarrello,
  numItem,
  hasOnlyHorizontalPadding,
}: CarrelloFooterTitleRowProps) => {
  const [labelMultipla, labelSistema] = useGetLabelsByKeys(['multipla', 'sistema']);
  const tipoCarrelloLabel = useMemo(() => {
    switch (tipoCarrello) {
      case TipoCarrello.Multipla:
        return labelMultipla;
      case TipoCarrello.Sistema:
        return labelSistema;
    }
  }, [labelMultipla, labelSistema, tipoCarrello]);

  const itemNumber = useMemo(() => {
    if (tipoCarrello === TipoCarrello.Multipla) {
      return numItem;
    }
    return null;
  }, [numItem, tipoCarrello]);

  return (
    <p className={`${styles.paragraph} ${hasOnlyHorizontalPadding ? styles.hasOnlyHorizontalpadding : ''}`}>
      {tipoCarrelloLabel} {itemNumber && <span>{`(${itemNumber})`}</span>}
    </p>
  );
};
